<template>
  <div class="web">
    <div class="post">
      <div class="postAdd">
        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="goDetail()">发布职位</el-button>
      </div>
      <div class="postList" v-loading="loading">
        <div style="margin-bottom: 10px" v-for="(item, index) in postList" :key="index" @click="goDetail(item)">
          <el-card shadow="hover" :body-style="{padding: '0px'}">
            <div class="postListBox">
              <el-row :gutter="10">
                <el-col :span="8">
                  <div class="job_name">{{item.job_name}}</div>
                  <div class="postContent">
                    <span>{{item.work_experience}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{item.educational_require}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{item.salary_package}}{{item.salary_package === '面议'?'':'元/月'}}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div
                    class="postStatus"
                    :class="item.status===1?'openStatus':'closeStatus'"
                  >{{item.status===1?'招聘中':'已停止招聘'}}</div>
                  <div style="text-align: center;padding-top: 10px" :class="item.status===1?'openStatus':'closeStatus'">{{item.createTime}}</div>
                </el-col>
                <el-col :span="8">
                  <div class="postBtn">
                    <el-link class="postBtnBox" type="primary" icon="el-icon-refresh" @click="$event.stopPropagation();weChatModal('刷新')">刷新</el-link>
                    <el-link class="postBtnBox" type="primary" icon="el-icon-top" @click="$event.stopPropagation();weChatModal('置顶')">置顶</el-link>
                    <el-link class="postBtnBox" type="primary" icon="el-icon-edit" @click="goDetail(item)">编辑</el-link>
                    <el-popconfirm :title="'确定'+ (item.status===1?'关闭':'打开') +item.job_name+'吗？'" @confirm="closePost(item)">
                        <el-link slot="reference" class="postBtnBox" type="primary" icon="el-icon-circle-close" @click="$event.stopPropagation()">{{item.status===1?'关闭':'打开'}}</el-link>
                    </el-popconfirm>
                    <el-popconfirm :title="'确定删除'+item.job_name+'吗？'" @confirm="delPost(item,index)">
                        <el-link slot="reference" class="postBtnBox" type="primary" icon="el-icon-delete" @click="$event.stopPropagation()">删除</el-link>
                    </el-popconfirm>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <page :total="total" @getList="getPost" />

    <!-- 刷新和置顶 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="weChatDialog"
      width="30%">
      <img :src="weChatCode" class="weChatCode" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { toTime } from '@/js/common.js'
import page from "@/components/page";
import { getWeChatCode } from '@/js/common.js'

export default {
  components: {
    page
  },
  data() {
    return {
      total: 0,
      page: {
        page: 1,
        size: 10
      },
      postList: [],
      loading: true,
      weChatDialog: false,
      dialogTitle: '',
      weChatCode: ''
    };
  },
  mounted() {
    this.getPost();
  },
  methods: {

    // 刷新和置顶
    weChatModal(title) {
      this.dialogTitle = title
      this.weChatDialog = !this.weChatDialog
      getWeChatCode(this, 'bossjoin/pages/postPublish/postPublish', '1')
    },

    // 获取职位列表
    getPost(page) {
      if(page) {
        this.page.page = page
      } else {
        this.page.page = 1
      }
      this.loading = true
      this.api.get('/5cef405d39ad5', this.page).then(r => {
        this.total = r.data.count
        this.postList = r.data.list
        this.loading = false
        this.postList.forEach(o=>{
          o.createTime = toTime(o.createTime*1000 ,'yyyy-MM-dd hh:mm:ss')
          if(o.educational_require) {
            o.educational_require = JSON.parse(o.educational_require)
            if(typeof o.educational_require) {
              o.educational_require = o.educational_require[0]
            }
          }
        })
      })
    },

    // 关闭职位
    closePost(o) {
      let obj = {
        jid: o.jid,
        status: o.status === 1?0:1
      }
      this.api.get('/5cef50dd34a7a', obj).then(r => {
        o.status = o.status === 1?0:1
        this.$message({
          message: o.status === 1?'已开启' + o.job_name:'已关闭' + o.job_name,
          type: 'success'
        });
      })
    },

    // 删除职位
    delPost(o, i) {
      this.api.get('/5cef3d14e4a3a', { jid: o.jid}).then(r => {
        this.postList.splice(i,1)
        this.$message({
          message: '删除'+ o .job_name +'成功',
          type: 'success'
        });
      })
    },

    // 添加和编辑职位
    goDetail(o) {
        this.$router.push({
            path: '/boss/postDetail',
            query: {
                jid: o?o.jid:''
            }
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.post {
  background: white;
  padding: 20px;
  margin-top: 20px;
  .postList {
    padding-top: 20px;
    .postListBox {
      padding: 24px 20px 24px 40px;
      cursor: pointer;
      .postContent {
        padding-top: 10px;
        font-size: 13px;
        color: #757575;
      }
      .postStatus {
        text-align: center;
      }
      .closeStatus {
        color: #aaa;
      }
      .closeStatus::before {
        background: #aaaaaa;
      }
      .openStatus::before {
        background: #ff5b12;
      }
      .postStatus::before {
        content: "";
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
        transform: translateY(-2px);
        margin-right: 5px;
      }
      .postBtn {
        text-align: right;
        line-height: 48px;
        .postBtnBox {
          margin-left: 10px;
          line-height: initial;
        }
      }
    }
    .postListBox:hover {
      .job_name {
        color: #ff5b12;
      }
    }
  }
}

.weChatCode {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/boss/post.vue